import React from 'react';
import { Select, type SelectProps } from '../select/select';
import { Input, type InputProps } from '../input/input';
import { ComponentSize } from '../select/__commons__/selectCommons';

/* make width dynamic */
const wClass: Record<ComponentSize, string> = {
    xs: 'w-24',
    sm: 'w-32',
    md: 'w-40',
    lg: 'w-48',
    xl: 'w-56',
};

const styles = {
    parentWrapper: 'flex flex-row items-start',
    // style overrides to make two components fit together
    dropdownTriggerButton: `rounded-none rounded-tl-lg rounded-bl-lg border-r-0 h-[38px] text-sm`, // h class needed as sizes don't match
    inputBase: `!rounded-none !rounded-tr-lg !rounded-br-lg`,
};

export type SelectAndInputProps = { select: SelectProps; input: InputProps; width?: ComponentSize };

export const SelectAndInput: React.FC<SelectAndInputProps> = (props) => {
    const { select, input, width = 'xs' } = props;
    return (
        <div className={styles.parentWrapper}>
            <Select {...select} buttonClassName={`${styles.dropdownTriggerButton} ${wClass[width]}`} />
            <Input {...input} inputBaseClassName={`${styles.inputBase} ${wClass[width]}`} />
        </div>
    );
};
